var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { TextMicro } from "../typography";
import Container from "./container";
import getPillColor from "./colors";
import PillIcon from "./icon";
var Pill = forwardRef(function (_a, ref) {
    var children = _a.children, background = _a.background, color = _a.color, hollow = _a.hollow, icon = _a.icon, reverse = _a.reverse, tiny = _a.tiny, rest = __rest(_a, ["children", "background", "color", "hollow", "icon", "reverse", "tiny"]);
    var flavour = rest.flavour;
    if (tiny)
        return (React.createElement(Container, __assign({ tiny: true, background: background, hollow: hollow, ref: ref }, rest)));
    return (React.createElement(Container, __assign({ background: background, hollow: hollow, ref: ref }, rest, { gap: 1 }),
        !reverse && React.createElement(PillIcon, { icon: icon, color: color, hollow: hollow, flavour: flavour }),
        React.createElement(TextMicro, { color: color ? color : hollow ? getPillColor("color", flavour) : "bright", strong: true }, children),
        reverse && React.createElement(PillIcon, { icon: icon, color: color, hollow: hollow, flavour: flavour })));
});
export default Pill;
